var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSandClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECEFF1"
    },
    d: "M288,90.976V16c0-4.256-1.696-8.32-4.672-11.328S276.256,0,272,0H48c-8.832,0-16,7.168-16,16v74.976 C32,129.44,46.976,165.6,74.176,192.8l31.2,31.2l-31.2,31.2C46.976,282.432,32,318.56,32,357.024v75.008 c0,4.256,1.696,8.32,4.672,11.328s7.072,4.672,11.328,4.672L272,448c8.832,0,16-7.168,16-16v-75.008 c0-38.464-14.976-74.624-42.176-101.824L214.624,224l31.2-31.232C273.024,165.6,288,129.44,288,90.976z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607D8B"
    },
    d: "M16,32C7.168,32,0,24.864,0,16C0,7.2,7.168,0,16,0h288c8.832,0,16,7.168,16,16s-7.168,16-16,16H16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607D8B"
    },
    d: "M304,448H16c-8.8,0-16-7.2-16-16l0,0c0-8.8,7.2-16,16-16h288c8.8,0,16,7.2,16,16l0,0 C320,440.8,312.8,448,304,448z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0BEC5"
    },
    d: "M64,64v26.976c0,29.92,11.648,58.016,32.8,79.2c0,0,63.2,49.6,63.2,53.824l0,0 c0-4.224,63.2-53.856,63.2-53.856c21.152-21.152,32.8-49.28,32.8-79.168V64H64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0BEC5"
    },
    d: "M64,416v-26.976c0-29.92,11.648-58.016,32.8-79.2c0,0.032,63.2-49.6,63.2-53.824l0,0 c0,4.224,63.2,53.856,63.2,53.856c21.152,21.152,32.8,49.28,32.8,79.2V416H64z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M304,416h-16v-59.008c0-38.464-14.976-74.624-42.176-101.824l-6.688-6.656 C209.984,279.936,192,321.856,192,368c0,28.832,7.104,55.968,19.424,80H272h32c8.8,0,16-7.2,16-16S312.8,416,304,416z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2196F3"
    },
    cx: 368,
    cy: 368,
    r: 144
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M416,432c-4.096,0-8.192-1.568-11.328-4.672l-48-48C353.696,376.32,352,372.256,352,368v-64 c0-8.832,7.168-16,16-16s16,7.168,16,16v57.376l43.328,43.328c6.24,6.24,6.24,16.384,0,22.624C424.192,430.432,420.096,432,416,432z "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandClock);
export default __webpack_public_path__ + "static/media/sand-clock.5a26e6f2725f304985e7fa78d92e68bc.svg";
export { ForwardRef as ReactComponent };